import t from "styled-components";
import e from "../../../utils/colors.js";
import { device as o } from "../../../utils/device.js";
const p = t.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  position: relative;
`, s = t.button`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: ${e.white};
  background-color: ${e.blueGrey};
  border: 0;
  padding: 0.6rem 1rem;
  height: 60px;

  @media ${o.isDesktop} {
    height: auto;
  }

  svg {
    path {
      fill: ${e.white};
    }
  }

  &:hover,
  &:focus {
    background-color: ${e.blueGrey50};

    color: ${e.blueGrey};

    div {
      color: ${e.blueGrey};
    }
    svg {
      path {
        fill: ${e.blueGrey};
      }
    }
  }
`, c = t.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  padding-left: 18px;
  justify-content: flex-start;
  align-items: center;

  @media ${o.isDesktop} {
    padding: 0;
  }
`, a = t.div`
  flex-basis: 15%;
  display: flex;
  align-self: center;
  justify-content: center;
  pointer-events: none;
  padding-top: 5px;

  @media ${o.isDesktop} {
    display: none !important;
  }
`, d = t.div`
  font-family: VIC;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.32px;
  color: ${e.white};
`, i = t.div`
  svg {
    width: 15px;
    height: 15px;
    box-sizing: content-box;

    &:before,
    &:after {
      box-sizing: content-box;
    }
  }
`, f = t(i)`
  margin-top: 6px;
`, g = t.div`
  background-color: ${e.white};
  margin-top: 0px;
  margin-bottom: 50px;
`;
export {
  s as Button,
  g as Content,
  i as IconWrapper,
  c as LoginLeftWrapper,
  a as LoginRightWrapper,
  d as Text,
  f as UserIconWrapper,
  p as Wrapper
};
